import { useEffect, useState } from "react";
import { RiLogoutCircleRLine } from 'react-icons/ri';
import { Outlet } from "react-router-dom";
import { map } from "lodash";

import { SidebarMenuCard, SidebarMenuItem } from "../../types/types"
import { classNames } from "../../utils/classes";

import { SidebarMenuCardComponent } from "./sidebar-menu-card";
import { SidebarMenuItemComponent } from "./sidebar-menu-item";
import { NavbarMenu } from "../navbar/navbar-menu";
import { useAuthActions } from "../../services/actions/auth.actions";
import NewVersionBanner from "../widgets/new-version-banner";

interface props {
  items: SidebarMenuItem[];
  card: SidebarMenuCard;
}

export const SidebarMenu: React.FC<props> = ({ items, card }) => {
  const [open, setOpen] = useState<boolean>(false);
  const { signOut } = useAuthActions();

  useEffect(() => {
    const handleClickOutside = (e: any) => {
      if (e.target.id !== 'sidebar' && e.target.id !== 'burger-btn' && e.target.id !== 'burger-icon' && open) setOpen(false);

    };

    if (open) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [open]);

  const handleToggle = () => setOpen(!open);

  const handleSignOut = async () => {
    await signOut();
  }

  return (
    <div>
      <NewVersionBanner />
      <NavbarMenu toggle={handleToggle} card={card} />
      <div id='sidebar' className={classNames('gm-sidebar-menu', open ? 'expanded' : 'collapsed')}>
        <div className="gm-menu-info-container">
          {open && <SidebarMenuCardComponent card={card} />}
          {open && map(items, (e) => <SidebarMenuItemComponent key={e.id} item={e} />)}
        </div>
        {open &&
          <button className="gm-logout-btn" type="button" onClick={handleSignOut}>
            <RiLogoutCircleRLine size={20} />
            <span>Cerrar Sesión</span>
          </button>
        }
      </div>
      <div className="gm-page-container">
        <Outlet />
      </div>
    </div>
  );
}
